import '../styles/NetworkSection.css';

export default function NetworkSection() {
  return (
    <section className="network-section">
      <div className="network-text">
        <h2 className="network-heading">Dev Mainnet Network</h2>
        <p className="network-desc">
          Where wallets, apps, and users connect to drive UX
          innovation, expand the ecosystem, and guide the network
          toward a decentralized, permissionless future.
        </p>
      </div>

      <LogoMark />
    </section>
  );
}

function LogoMark() {
  return (
    <svg
      className="network-mark"
      viewBox="0 0 200 200"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="100" cy="100" r="100" fill="#ffffff" />
      <path
        d="M40 90a60 60 0 0 1 120 0"
        stroke="#16171a"
        strokeWidth="14"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M34 122l26 26 26-26 26 26 26-26"
        stroke="#16171a"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}